import { render, staticRenderFns } from "./ListEditor.vue?vue&type=template&id=4c2f432c&scoped=true&"
import script from "./ListEditor.vue?vue&type=script&lang=ts&"
export * from "./ListEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ListEditor.vue?vue&type=style&index=0&id=4c2f432c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2f432c",
  null
  
)

export default component.exports